(function (root) {
  'use strict';
  var ns = 'http://www.w3.org/2000/svg';
  function el(tag, attrs, content) {
    var node = document.createElementNS(ns, tag);
    Object.keys(attrs || {}).forEach(function (key) {node.setAttribute(key, attrs[key]);});
    if (content !== undefined) node.textContent = content;
    return node;
  }
  function star(svg, x, y, size, color) {
    svg.appendChild(el('path',{d:'M'+x+' '+(y-size)+' Q'+x+' '+y+' '+(x+size)+' '+y+' Q'+x+' '+y+' '+x+' '+(y+size)+' Q'+x+' '+y+' '+(x-size)+' '+y+' Q'+x+' '+y+' '+x+' '+(y-size),fill:color}));
  }
  function render(design, values, photos, options) {
    options = options || {};
    var prefix = options.prefix || ('hc-' + design.id);
    var svg = el('svg',{xmlns:ns,viewBox:'0 0 '+design.width+' '+design.height,role:'img','aria-label':design.name+' personalized holiday card','data-card-design':design.id});
    svg.appendChild(el('rect',{width:design.width,height:design.height,fill:design.background}));
    var a = design.accent, w = design.width, h = design.height;
    var line = function(x1,y1,x2,y2){svg.appendChild(el('line',{x1:x1,y1:y1,x2:x2,y2:y2,stroke:a,'stroke-width':.7}));};
    if (['frame','botanical','midnight'].includes(design.decoration)) svg.appendChild(el('rect',{x:20,y:20,width:w-40,height:h-40,fill:'none',stroke:a,'stroke-width':.7}));
    if(design.decoration==='cheers'){line(35,563,465,563);star(svg,250,34,9,a);}
    if(design.decoration==='editorial'){line(42,133,458,133);line(378,335,378,568);star(svg,410,460,16,a);}
    if(design.decoration==='night'){star(svg,250,39,13,a);line(109,581,391,581);}
    if(design.decoration==='botanical'){
      [0,1].forEach(function(side){
        var group=el('g',{transform:side?'translate(500 0) scale(-1 1)':''});
        group.appendChild(el('path',{d:'M31 151 Q85 125 124 126',fill:'none',stroke:a,'stroke-width':1}));
        for(var j=0;j<6;j++){var x=42+j*13,y=146-j*3;group.appendChild(el('path',{d:'M'+x+' '+y+' q-5 -15 4 -20 q5 12 -4 20 M'+x+' '+y+' q9 9 18 3 q-9 -9 -18 -3',fill:'none',stroke:a,'stroke-width':.8}));}
        svg.appendChild(group);
      });
      line(80,645,205,645);line(295,645,420,645);
    }
    if(design.decoration==='midnight'){star(svg,552,80,15,a);line(468,263,635,263);star(svg,644,417,6,a);star(svg,467,351,5,a);}
    if(design.decoration==='chapters'){line(32,188,468,188);}
    if(design.decoration==='gathered'){line(245,459,315,459);line(385,459,455,459);}
    var defs = el('defs');svg.appendChild(defs);
    design.photos.forEach(function(slot,index){
      var clip=el('clipPath',{id:prefix+'-slot-'+index});clip.appendChild(el('rect',{x:slot.x,y:slot.y,width:slot.w,height:slot.h}));defs.appendChild(clip);
      var group=el('g',{'data-photo-slot':index,tabindex:options.interactive?'0':'-1',role:options.interactive?'button':'img','aria-label':'Photo '+(index+1)+(options.interactive?': upload or crop':''),'clip-path':'url(#'+prefix+'-slot-'+index+')'});
      group.appendChild(el('rect',{x:slot.x,y:slot.y,width:slot.w,height:slot.h,fill:design.background==='#183d32'?'#dce0d3':'#e8e4db'}));
      if(photos[index])group.appendChild(el('image',{x:slot.x,y:slot.y,width:slot.w,height:slot.h,href:photos[index],preserveAspectRatio:'xMidYMid slice'}));
      else {
        group.appendChild(el('text',{x:slot.x+slot.w/2,y:slot.y+slot.h/2-4,'text-anchor':'middle','font-family':'Georgia,serif','font-size':28,fill:'#5b6557'},'+'));
        group.appendChild(el('text',{x:slot.x+slot.w/2,y:slot.y+slot.h/2+23,'text-anchor':'middle','font-family':'Arial,sans-serif','font-size':12,fill:'#5b6557'},'ADD PHOTO '+(index+1)));
      }
      svg.appendChild(group);
    });
    design.texts.forEach(function(field){
      var value = Object.prototype.hasOwnProperty.call(values,field.key)?values[field.key]:field.value;
      var node=el('text',{x:field.x,y:field.y,fill:field.color,'font-family':field.font==='script'?'FP Holiday Script':'FP Holiday Serif','font-size':field.size,'letter-spacing':field.spacing,'text-anchor':'middle','data-text-key':field.key,'data-max-width':field.width,role:options.interactive?'button':'img',tabindex:options.interactive?'0':'-1','aria-label':field.label+': '+value},value);
      svg.appendChild(node);
    });
    return svg;
  }
  function fit(svg) {
    svg.querySelectorAll('[data-text-key]').forEach(function(node){
      var width=node.getComputedTextLength(),max=Number(node.dataset.maxWidth),size=Number(node.getAttribute('font-size'));
      if(width>max)node.setAttribute('font-size',Math.max(8,size*max/width));
    });
  }
  root.FoxPrintHolidayRenderer = {render:render,fit:fit};
}(typeof window !== 'undefined' ? window : globalThis));
